<div>
  <a [href]="getUrl()" class="btn campaign-button" target="_blank">
    {{getLabel() || 'Link Text'}}
  </a>
</div>
